/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ReleaseReleaseNoteProtocolsGetDetailRequest,
  ReleaseReleaseNoteProtocolsGetDetailResponse,
  ReleaseReleaseNoteProtocolsGetListResponse,
  ReleaseReleaseNoteProtocolsGetPopupResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ReleaseNote<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags ReleaseNote
   * @name PopupList
   * @request GET:/release-note/popup
   */
  popupList = (params: RequestParams = {}) =>
    this.http.request<ReleaseReleaseNoteProtocolsGetPopupResponse, any>({
      path: `/release-note/popup`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReleaseNote
   * @name ListList
   * @request GET:/release-note/list
   */
  listList = (params: RequestParams = {}) =>
    this.http.request<ReleaseReleaseNoteProtocolsGetListResponse, any>({
      path: `/release-note/list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReleaseNote
   * @name DetailCreate
   * @request POST:/release-note/detail
   */
  detailCreate = (data: ReleaseReleaseNoteProtocolsGetDetailRequest, params: RequestParams = {}) =>
    this.http.request<ReleaseReleaseNoteProtocolsGetDetailResponse, any>({
      path: `/release-note/detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
